// pages/admin/OrganizationManagement.tsx
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { useAdmin } from "../../context/AdminContext";
import { Organization } from "../../context/types";

const OrganizationManagement: React.FC = () => {
  const { organizations, loading, addOrganization } = useAdmin();
  const [openDialog, setOpenDialog] = useState(false);
  const [newOrg, setNewOrg] = useState({
    name: "",
    organizationKey: "",
    letsLaunchAccess: false,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setNewOrg((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      await addOrganization(newOrg);
      setOpenDialog(false);
      setNewOrg({
        name: "",
        organizationKey: "",
        letsLaunchAccess: false,
      });
    } catch (error) {
      console.error("Error creating organization:", error);
    }
  };

  return (
    <Box p={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4">Organization Management</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenDialog(true)}
        >
          Add Organization
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Key</TableCell>
                <TableCell>LetsLaunch Access</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {organizations.map((org: Organization) => (
                <TableRow key={org._id}>
                  <TableCell>{org.name}</TableCell>
                  <TableCell>{org.organizationKey}</TableCell>
                  <TableCell>{org.letsLaunchAccess ? "Yes" : "No"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Add Organization Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Add New Organization</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={2}>
            <TextField
              name="name"
              label="Organization Name"
              value={newOrg.name}
              onChange={handleInputChange}
              fullWidth
            />
            <TextField
              name="organizationKey"
              label="Organization Key"
              value={newOrg.organizationKey}
              onChange={handleInputChange}
              fullWidth
            />
            <Box display="flex" alignItems="center">
              <input
                type="checkbox"
                name="letsLaunchAccess"
                checked={newOrg.letsLaunchAccess}
                onChange={handleInputChange}
                id="letsLaunchAccess"
              />
              <label htmlFor="letsLaunchAccess" style={{ marginLeft: "8px" }}>
                LetsLaunch Access
              </label>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={!newOrg.name || !newOrg.organizationKey}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default OrganizationManagement;
